import config from 'config/config.json';

const categories = {
  categories: [
    {
      title: 'New',
      categorySlug: 'brands',
      categoryName: 'Brands',
      elementsKey: 'latest_arrivals',
    },
    {
      title: 'Bags',
      categorySlug: 'bags',
      categoryName: 'Bags',
      elementsKey: 'bags',
    },
    {
      title: 'Shoes',
      categorySlug: 'shoes',
      categoryName: 'Shoes',
      elementsKey: 'shoes',
    },
    {
      title: 'Clothing',
      categorySlug: 'apparel',
      categoryName: 'Apparel',
      elementsKey: 'apparel',
      styleElementsKey: 'apparel_styles',
    },
    {
      title: 'Accessories',
      categorySlug: 'accessories',
      categoryName: 'Accessories',
      elementsKey: 'accessories',
      subCategoryElementsKey: 'accessories_categories',
    },
    {
      title: 'Watches',
      categorySlug: 'watches',
      categoryName: 'Watches',
      elementsKey: 'watches',
    },
    {
      title: 'Jewellery',
      categorySlug: 'jewellery',
      categoryName: 'Jewellery',
      elementsKey: 'jewellery',
    },
  ],
  menuData: `${config.CLOUDFRONT_URL}/categories.json`,
};

export default categories;
